var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMagicSelectionMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Magic Selection Minus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 19.775H21.75V4.22499H9.6125V6.10482H19.875V17.9H4.13033V11.6125H2.25V19.775ZM10.7969 10.7969L12 8.14999L13.2031 10.7969L15.85 12L13.2031 13.2031L12 15.85L10.7969 13.2031L8.15 12L10.7969 10.7969ZM0.5 7.3125H3.4375H5.3125H8.25V5.4375H5.3125H3.4375H0.5V7.3125Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagicSelectionMinus);
export default __webpack_public_path__ + "static/media/icon-magic-selection-minus.e29f29818bc23dc1371f92e4f69fb90c.svg";
export { ForwardRef as ReactComponent };